import { Suspense, lazy } from 'react';
import { Navigate, useRoutes, Outlet } from 'react-router-dom';
// layouts
import MainLayout from '../layouts/main';
import DashboardLayout from '../layouts/dashboard';
import LogoOnlyLayout from '../layouts/LogoOnlyLayout';
import TransactionLayout from '../layouts/TransactionLayout';
import BlankLayout from '../layouts/BlankLayout';
// guards
import GuestGuard from '../guards/GuestGuard';
import AuthGuard from '../guards/AuthGuard';
// import RoleBasedGuard from '../guards/RoleBasedGuard';
// config
import { PATH_AFTER_LOGIN } from '../config';
// components
import LoadingScreen from '../components/LoadingScreen';

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<LoadingScreen loadable={true} />}>
      <Component {...props} />
    </Suspense>
  );

export default function Router() {
  return useRoutes([
    {
      path: '',
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        // Public Routes
        { path: 'home', element: <Home /> },
        { path: 'home/:section', element: <Home /> },
        { path: 'games/:categSlug', element: <GamesByCateg /> },
        { path: 'games/:categSlug/:companyId', element: <GamesByCateg /> },
        { path: '/vip', element: <Vip /> },
        { path: '/history', element: <History /> },
        { path: 'page/:customPage', element: <CustomPage /> },

        // Protected Routes
        {
          path: 'history',
          element: (
            <AuthGuard>
              <Outlet />
            </AuthGuard>
          ),
          children: [{ path: '/history', element: <History /> }],
        },

        {
          path: 'user',
          element: (
            <AuthGuard>
              <Outlet />
            </AuthGuard>
          ),
          children: [
            { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
            { path: 'account', element: <AccountProfile /> },
            { path: 'banks', element: <MemberBankList /> },
            { path: 'missions', element: <Mission /> },
            { path: 'rewards', element: <Rewards /> },
          ],
        },

        // Referral Route
        {
          path: '/',
          element: (
            <AuthGuard>
              <DashboardLayout />
            </AuthGuard>
          ),
          children: [
            { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
            { path: '/referral', element: <Referral /> },
            { path: '/referral/refer-a-friend', element: <ReferAFriend /> },
          ],
        },

        // Bonus Route
        {
          path: '/',
          element: (
            <AuthGuard>
              <DashboardLayout />
            </AuthGuard>
          ),
          children: [
            { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
            { path: '/agent', element: <Agent /> },
          ],
        },
      ],
    },
    {
      path: 'auth',
      children: [
        {
          path: 'login',
          element: <DashboardLayout />,
          children: [
            {
              element: <Home popupAuth={'1'} />,
              index: true,
            },
          ],
        },
        {
          path: 'register',
          element: <DashboardLayout />,
          children: [
            {
              element: <Home popupAuth={'2'} />,
              index: true,
            },
          ],
        },
        { path: 'login-unprotected', element: <Login /> },
        { path: 'register-unprotected', element: <Register /> },
        {
          path: 'reset-password',
          element: <DashboardLayout />,
          children: [
            {
              element: <Home />,
              index: true,
            },
          ],
        },
        { path: 'new-password', element: <NewPassword /> },
        { path: 'verify', element: <VerifyCode /> },
      ],
    },

    // Home Routes
    // {
    //   path: '/',
    //   element: (
    //     // <AuthGuard>
    //     <DashboardLayout />
    //     // </AuthGuard>
    //   ),
    //   children: [
    //     { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
    //     { path: 'home', element: <Home /> },
    //     { path: 'games/:categSlug', element: <GamesByCateg /> },
    //     { path: 'games/:categSlug/:companyId', element: <GamesByCateg /> },
    //     { path: '/vip', element: <Vip /> },
    //   ],
    // },

    // History Routes
    // {
    //   path: 'history',
    //   element: (
    //     <AuthGuard>
    //       <DashboardLayout />
    //     </AuthGuard>
    //   ),
    //   children: [
    //     { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
    //     { path: '/history/bet', element: <GameHistory /> },
    //     { path: '/history/transaction', element: <TransactionHistory /> },
    //   ],
    // },

    // User Routes
    // {
    //   path: 'user',
    //   element: (
    //     <AuthGuard>
    //       <DashboardLayout />
    //     </AuthGuard>
    //   ),
    //   children: [
    //     { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
    //     { path: '/user/account', element: <AccountProfile /> },
    //     { path: '/user/banks', element: <MemberBankList /> },
    //   ],
    // },

    {
      path: 'user',
      element: (
        <AuthGuard>
          <TransactionLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: '/user/wallet', element: <Wallet /> },
      ],
    },

    // Invite Routes
    {
      path: '/',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: 'invite', element: <Invite /> },
      ],
    },

    // Promotion Routes
    {
      path: '/',
      element: (
        // <AuthGuard>
        <DashboardLayout />
        // </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: 'promotion', element: <Promotion /> },
        { path: 'promotion/view/:promotionId', element: <ViewPromotion /> },
      ],
    },

    {
      path: 'payStatus',
      element: <LogoOnlyLayout />,
      children: [
        {
          path: ':paymentMethod',
          element: <PaymentStatus />,
          index: true,
        },
      ],
    },

    // AngPau
    {
      path: '/angpau',
      element: (
        // <AuthGuard>
        <AngPau />
        // </AuthGuard>ß
      ),
    },

    // Download Page
    {
      path: '',
      element: <BlankLayout />,
      children: [{ path: 'download', element: <DownloadPage /> }],
    },

    // Main Routes
    {
      path: '*',
      element: <LogoOnlyLayout />,
      children: [
        { path: 'coming-soon', element: <ComingSoon /> },
        { path: 'maintenance', element: <Maintenance /> },
        { path: '500', element: <Page500 /> },
        { path: '404', element: <Page404 /> },
        { path: '403', element: <Page403 /> },
        { path: '*', element: <Navigate to="/404" replace /> },
      ],
    },
    // {
    //   path: '/',
    //   element: <MainLayout />,
    //   children: [
    //     { element: <HomePage />, index: true },
    //     { path: 'about-us', element: <About /> },
    //     { path: 'contact-us', element: <Contact /> },
    //     { path: 'faqs', element: <Faqs /> },
    //   ],
    // },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}

// AUTHENTICATION
const Login = Loadable(lazy(() => import('../pages/auth/Login')));
const Register = Loadable(lazy(() => import('../pages/auth/Register')));
const ResetPassword = Loadable(lazy(() => import('../pages/auth/ResetPassword')));
const NewPassword = Loadable(lazy(() => import('../pages/auth/NewPassword')));
const VerifyCode = Loadable(lazy(() => import('../pages/auth/VerifyCode')));

// HOME
const Home = Loadable(lazy(() => import('../views/game/Home')));

// GAMES
const GamesByCateg = Loadable(lazy(() => import('../views/game/GamesByCateg')));

// GAME HISTORY
const GameHistory = Loadable(lazy(() => import('../views/history/GameHistory')));

// TRANSACTION HISTORY
const TransactionHistory = Loadable(lazy(() => import('../views/history/TransactionHistory')));

// HISTORY
const History = Loadable(lazy(() => import('../views/history/History')));

// USER
const AccountProfile = Loadable(lazy(() => import('../views/user/AccountProfile')));
const MemberBankList = Loadable(lazy(() => import('../views/user/MemberBankList')));
const Wallet = Loadable(lazy(() => import('../views/user/Wallet')));
const Mission = Loadable(lazy(() => import('../views/user/Mission')));
const Rewards = Loadable(lazy(() => import('../views/user/Rewards')));

// INVITE
const Invite = Loadable(lazy(() => import('../views/share/Invite')));

// PROMOTION
const Promotion = Loadable(lazy(() => import('../views/promotion/Promotion')));
const ViewPromotion = Loadable(lazy(() => import('../views/promotion/ViewPromotion')));
const AngPau = Loadable(lazy(() => import('../views/promotion/AngPau')));

// PAYMENT STATS
const PaymentStatus = Loadable(lazy(() => import('../pages/PaymentStatus')));

// REFERRAL
const Referral = Loadable(lazy(() => import('../views/referral/Referral')));
const ReferAFriend = Loadable(lazy(() => import('../views/referral/ReferAFriend')));

// Bonus
const Vip = Loadable(lazy(() => import('../views/referral/Vip')));
const Agent = Loadable(lazy(() => import('../views/referral/Agent')));

// CUSTOM PAGE
const CustomPage = Loadable(lazy(() => import('../views/CustomPages')));

// DOWNLOAD PAGE
const DownloadPage = Loadable(lazy(() => import('../views/DownloadPage')));

// MAIN
const ComingSoon = Loadable(lazy(() => import('../pages/ComingSoon')));
const Maintenance = Loadable(lazy(() => import('../pages/Maintenance')));
const Page500 = Loadable(lazy(() => import('../pages/Page500')));
const Page403 = Loadable(lazy(() => import('../pages/Page403')));
const Page404 = Loadable(lazy(() => import('../pages/Page404')));
